import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ORGANIZATION_ADMIN, PROJECT_ADMIN, PROJECT_MONITOR, SYSTEM_ADMIN } from 'app/types/authority';
import { PermissionGuard } from 'app/shared';
import { MainComponent } from 'app/layouts';
import { AuthGuard } from 'app/auth/auth.guard';



export const ADMIN_ROUTES: Routes = [{
  path: 'core',
  component: MainComponent,
  canActivate: [AuthGuard],
  canActivateChild: [AuthGuard],
  children: [{
    path: 'account',
    loadChildren: () => {
      return import('app/account/account.module').then((m) => m.ManagementPortalAccountModule);
    }
  }, {
    path: 'admin',
    canActivate: [PermissionGuard],
    loadChildren: () => {
      return import('app/admin/admin.module').then((m) => m.ManagementPortalAdminModule);
    },
    data: {
      authorities: [SYSTEM_ADMIN]
    }
  }, {
    path: 'system',
    canActivate: [PermissionGuard],
    loadChildren: () => {
      return import('app/admin/system.module').then((m) => m.SystemModule);
    },
    data: {
      authorities: [SYSTEM_ADMIN]
    }
  }, {
    path: 'entities',
    canActivate: [PermissionGuard],
    loadChildren: () => {
      return import('app/entities/entity.module').then((m) => m.ManagementPortalEntityModule);
    },
    data: {
      authorities: [SYSTEM_ADMIN]
    }
  }, {
    path: 'organization',
    canActivate: [PermissionGuard],
    canActivateChild: [PermissionGuard],
    loadChildren: () => {
      return import('app/entities/organization/organization.module').then((m) => m.OrganizationModule);
    },
    data: {
      authorities: [SYSTEM_ADMIN, ORGANIZATION_ADMIN]
    }
  }, {
    path: 'study',
    canActivate: [PermissionGuard],
    canActivateChild: [PermissionGuard],
    loadChildren: () => {
      return import('app/entities/subject/general.subject.module').then((m) => m.SubjectModule);
    },
    data: {
      authorities: [SYSTEM_ADMIN, ORGANIZATION_ADMIN, PROJECT_ADMIN, PROJECT_MONITOR]
    }
  }, {
    path: '**',
    redirectTo: '/core/admin/organization'
  }],
}];

@NgModule({
  imports: [
    RouterModule.forChild(ADMIN_ROUTES)
  ],
  exports: [
    RouterModule,
  ],
})
export class CoreRoutingModule {
}

